import { useBreadcrumb } from "features/breadcrumbs";
import Container from "components/Container";
import ListaClientes from "./components/ListaClientes/index";

function ClientesListaPage() {
  useBreadcrumb([
    { name: "Administração" },
    {
      name: "Clientes",
      url: "/cadastros/clientes",
    },
  ]);
  return (
    <Container>
      <ListaClientes />
    </Container>
  );
}

export default ClientesListaPage;
